import clsx from 'clsx'
import { Image } from 'component/Image'
import { Link } from 'component/Link'
import { Space } from 'component/Space'
import { Typo } from 'component/Typo'
import { Vertical } from 'component/Vertical'
import { observer } from 'mobx-react-lite'
import { useDemo } from 'page/catalog/store/CatalogContext'
import { ui } from 'store/home/ui/HomeUiStore'
import banner_desktop from './banner-16x1.png'
import banner_mobile from './banner-6x1.png'
import css from './Banner.module.scss'

type Props = {
  top?: boolean
}

function fixPreview(url: string, small: boolean) {
  if (url !== 'preview') return url
  return small ? banner_mobile.src : banner_desktop.src
}

function isSameDomain(url: string) {
  if (typeof window === 'undefined') return false
  try {
    return new URL(url, location.href).hostname === location.hostname
  } catch {
    return false
  }
}

function getUrl(stand: boolean, url: string | undefined) {
  if (!url) return undefined
  if (!stand) return url
  return isSameDomain(url) ? url : undefined
}

export const Banner = observer(({ top }: Props) => {
  const { stand, product, data } = useDemo()
  const { small } = ui.window
  const { banners } = product
  const url = getUrl(stand, banners?.url)
  const image = small ? banners?.mobile : banners?.desktop
  const preview = data.preview && image === 'preview'
  const src = preview ? fixPreview(image, small) : image
  const className = clsx(css.banner, top ? css.top : css.bottom)

  if (!src) return null

  const banner = <Space className={className} center>
    <Image src={src} className={css.image} />
    {preview && <Vertical className={css.preview}>
      <Typo>BANNER {small ? '6:1' : '16:1'}</Typo>
      <Typo>{small ? '480 x 80' : '1240 x 80'}</Typo>
    </Vertical>}
  </Space>

  if (!url) return banner

  return <Link href={url} here={stand}>
    {banner}
  </Link>
})
